import { UAParser } from 'ua-parser-js';
import { useMemo, useContext } from 'react';
import { Context } from './UserAgentProvider';
import type { UserAgent, OS, Browser } from './types';

const BOT_UA = [
  '\\+https:\\/\\/developers.google.com\\/\\+\\/web\\/snippet\\/',
  'googlebot',
  'baiduspider',
  'gurujibot',
  'yandexbot',
  'slurp',
  'msnbot',
  'bingbot',
  'facebookexternalhit',
  'linkedinbot',
  'twitterbot',
  'slackbot',
  'telegrambot',
  'applebot',
  'pingdom',
  'tumblr',
];

export const useUserAgent = (): UserAgent => {
  let uaString = useContext(Context);
  if (uaString === undefined && typeof window !== 'undefined') {
    uaString = window.navigator.userAgent;
  }

  return useMemo(() => {
    const result: UAParser.IResult = new UAParser(uaString).getResult();
    const regex = new RegExp(`(${BOT_UA.join('|')})`, 'ig');
    const isBot = uaString ? regex.test(uaString.toLowerCase()) : false;

    const browser = (result.browser.name || 'unidentified') as Browser;
    const deviceType = result.device.type || null;
    const os = (result.os.name || 'unidentified') as OS;
    const engine = result.engine.name || 'unidentified';
    const isMobile = deviceType === 'mobile';
    const isTablet = deviceType === 'tablet';
    return {
      browser,
      deviceType,
      os,
      engine,
      isMobile,
      isTablet,
      source: uaString,
      isDesktop: !isMobile && !isTablet,
      isBot,
    };
  }, [uaString]);
};
